import React, { useState } from 'react';
import { Receipt, ReceiptText } from 'lucide-react';
import RecibosCobroPage from './RecibosCobroPage';
import RetencionesClientesPage from './RetencionesClientesPage';

// Herramienta unificada "Cobranzas": presenta en pestañas los dos flujos.
// No se fusionan los flujos internos (uno es 1 documento→N clientes y el otro
// 1 documento→1 cliente): solo se unifica la presentación y el acceso.
// El permiso es uno solo (key `cobranzas`), así que quien entra acá ve siempre
// las dos pestañas — ya no hay filtrado por herramienta.
const TABS = [
  { key: 'recibos', label: 'Cheques y Transferencias', icon: Receipt, Comp: RecibosCobroPage },
  { key: 'retenciones', label: 'OP + Retenciones', icon: ReceiptText, Comp: RetencionesClientesPage },
];

const CobranzasPage = () => {
  const tabs = TABS;
  const [active, setActive] = useState(tabs[0].key);

  const current = tabs.find((t) => t.key === active) || tabs[0];
  const Current = current.Comp;

  return (
    <div>
      {/* Barra de pestañas (solo si hay más de una herramienta disponible) */}
      {tabs.length > 1 && (
        <div className="flex items-center gap-2 mb-6 border-b border-gray-800">
          {tabs.map((t) => {
            const isActive = t.key === current.key;
            return (
              <button
                key={t.key}
                onClick={() => setActive(t.key)}
                className={`inline-flex items-center gap-2 px-4 py-2.5 text-sm font-bold rounded-t-lg -mb-px border-b-2 transition-colors ${
                  isActive
                    ? 'text-[#00a1df] border-[#00a1df]'
                    : 'text-gray-400 border-transparent hover:text-gray-200'
                }`}
              >
                <t.icon className="w-4 h-4" />
                {t.label}
              </button>
            );
          })}
        </div>
      )}

      <Current />
    </div>
  );
};

export default CobranzasPage;
